import { createContext } from 'react';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { ITransactionDesc } from './BuySellAdjustmentTableProvider';
import { ILogo } from '@widgets/AccountLevelPositionsTable/lib/PositionsTableProvider/PositionsTableContext';

type DateRange = [string | null, string | null];

export interface IBuySellAdjustmentTableContext {
    AssignPositionBody: any[];
    arrayWithLogos: ILogo[];
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    holdingLoading: boolean;
    desc: ITransactionDesc | null;
    setAccountId: (value: any) => void;
}

export const BuySellAdjustmentTableContext = createContext<IBuySellAdjustmentTableContext>({
    AssignPositionBody: [],
    paginationOptions: null,
    arrayWithLogos: [],
    holdingLoading: false,
    sortFieldName: '',
    desc: null,
    setAccountId: emptyFunc,
});
